/* eslint react/prop-types: 0 */
import React, { Fragment } from "react";

import SearchBuildings from "../../../common/SearchBuildings";
import {
  getTranslatedValue,
  translateStatic,
} from "../../../helpers/translationHelper";
import * as theme5Styles from "../scss/theme5.module.scss";

class BuildingSearch extends SearchBuildings {
  constructor(props) {
    super(props);
  }

  render() {
    const { propertyTypes, locale, defaultLocale } = this.props;

    return (
      <Fragment>
        <div className={`${theme5Styles.searchColm}`}>
          <div className={theme5Styles.filterSearch}>
            <input
              type="text"
              className={theme5Styles.field}
              name="search"
              value={this.state.searchForm.search}
              onChange={this.handleInputChange}
            />
            <button
              className={theme5Styles.srch}
              onClick={() => this.searchBuildings()}
            ></button>
          </div>
        </div>
        <div className={`${theme5Styles.filterC}`}>
          <div className={`${theme5Styles.filterRow}`}>
            <div className={theme5Styles.colm}>
              <select
                className={theme5Styles.field}
                name="type"
                value={this.state.searchForm.type}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("type", locale, defaultLocale)}
                </option>
                {(() => {
                  return propertyTypes.map((property_type) => {
                    return (
                      <option value={property_type.id} key={property_type.id}>
                        {getTranslatedValue(
                          property_type.translations,
                          "name",
                          locale,
                          defaultLocale
                        )}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
          </div>
          <div className={`${theme5Styles.filterBtns}`}>
            <button
              className={`${theme5Styles.btn} ${theme5Styles.btnSm} ${theme5Styles.btnDark}`}
              onClick={() => this.searchBuildings()}
            >
              {translateStatic("filter", locale, defaultLocale)}
            </button>
            <button
              className={`${theme5Styles.btn} ${theme5Styles.btnSm}`}
              onClick={() => this.clearSearchForm()}
            >
              {translateStatic("clear", locale, defaultLocale)}
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BuildingSearch;
